export default "__VITE_ASSET__efUSA1fh__"